module.exports = "<p>\n  statement6 works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/statement6/statement6.component.html
// module id = ./src/app/statement6/statement6.component.html
// module chunks = main